import React, {Component} from 'react';
import '../assets/css/main.css';
import {CopyToClipboard} from "react-copy-to-clipboard";
import axios from "axios";
import ReactGA from "react-ga";
import {isIE} from "react-device-detect";
import {IMG_URL, ADDY_URL} from '../config'
import {result_set} from "../assets/story_set";
import Ads from "./Ads";

class Main extends Component {
    state = {
        num_success_count: 0,
        success_count: 0,
        fail_count: 0,
        total_count: 0,
        mask_set: [],
    }

    async componentDidMount() {
        ReactGA.pageview('/mask');
        let success_count = 0;
        let fail_count = 0
        let total_count = 0
        axios.get(
            ADDY_URL + '/api/v1/story/mask/rank',
            {
                headers: {
                    'Authorization': "story_add_campus_312523"
                }
            }).then(({data: {data}}) => {
            if (data.success_count) {
                success_count = data.success_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                total_count += data.success_count;
            }
            if (data.fail_count) {
                fail_count = data.fail_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                total_count += data.fail_count;
            }

            this.setState({
                num_success_count: data.success_count,
                success_count: success_count,
                fail_count: fail_count,
                total_count: total_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                mask_set: data.mask_set || []
            })
        });
    }

    goStory() {
        this.props.history.push("/warning");
    }

    copyAlert(url) {
        ReactGA.event({
            category: "Story-2 [가면테스트]",
            action: "Share",
            label: "Main"
        });
        if (navigator.share) {
            navigator.share({
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        } else {
            alert('복사 되었습니다.');
        }
    }

    render() {
        const {success_count, fail_count, total_count, mask_set, num_success_count} = this.state;
        let ie_msg;
        if (isIE) {
            ie_msg = "해당 검사는 해당브라우저를 지원하지 않습니다. 다른 브라우저를 사용해주세요."
        }
        return (
            <div className="main">
                <div className="main_bg">
                    {
                        ie_msg &&
                        <p className="ie_msg">{ie_msg}</p>
                    }
                    <p className="easter_text">
                        Twowix
                    </p>
                    <div className="main_wrapper">
                        <div style={{width: "50%", textAlign: "left", display: "inline-block"}}>
                            <p className="main_label">가면찾기 테스트</p>
                        </div>
                        <div style={{
                            position: "relative",
                            zIndex: 55,
                            width: "50%",
                            textAlign: "right",
                            display: "inline-block",
                            verticalAlign: "top"
                        }}>

                            <CopyToClipboard text="https://story.addcampus.com/mask"
                                             onCopy={() => this.copyAlert("https://story.addcampus.com/mask")}>
                                <div className="main_share_btn">
                                    <img alt="icon" className="icon"
                                         src={IMG_URL + '/story/story_1/icon/share-icon-white.svg'}/>
                                    <p className="text">URL 복사하기</p>
                                </div>
                            </CopyToClipboard>
                        </div>
                        <div className="opacity_div">
                            <p className="sub_title">내가 쓴 가면 찾기</p>
                            <p className="story_title">에클린 백작부인의 만찬</p>
                            <p className="info_title"><img alt="sound_icon"
                                                           src={IMG_URL + '/story/story_1/icon/sound-on-yellow.svg'}/>사운드가
                                포함되어 있으니, 수업중이나 직장에선 조심조심…</p>
                            <div className="latter_compo">
                                <img key={1} alt="latter" className="latter_text"
                                     src={IMG_URL + '/story/story_2/main/latter_text.png'}/>
                                <img key={2} alt="latter" className="latter"
                                     src={IMG_URL + '/story/story_2/main/latter.png'}/>
                                <img key={3} alt="latter" className="latter_top"
                                     src={IMG_URL + '/story/story_2/main/latter_top.png'}/>
                                <img key={4} alt="latter" className="latter_bottom"
                                     src={IMG_URL + '/story/story_2/main/latter_bottom.png'}/>
                                <button key={5} className="latter_btn" onClick={() => this.goStory()}
                                        style={{zIndex: 55}}>
                                    만찬 참여하기
                                </button>
                            </div>
                        </div>
                        <div className="sub_opacity_div">
                            <Ads/>
                            <div style={{
                                width: "100%",
                                textAlign: "left",
                                display: "inline-block",
                                marginBottom: '10px'
                            }}>
                                <p className="result_text">초대된 사람 총 {total_count} 명</p>
                            </div>
                            <div style={{width: "50%", textAlign: "left", display: "inline-block"}}>
                                <p className="result_text">찾아낸 가면 <span
                                    style={{color: "#b8e986"}}>{success_count}</span> 개</p>
                            </div>
                            <div style={{width: "50%", textAlign: "right", display: "inline-block"}}>
                                <p className="result_text">잃어버린 얼굴 <span
                                    style={{color: "#ff2d55"}}>{fail_count}</span> 개</p>
                            </div>

                            <div className="main_mask_list">
                                {
                                    mask_set ?
                                        mask_set.map((item, index) => {
                                            return (
                                                <div key={index} className="main_rank_compo">
                                                    <img alt="mask"
                                                         src={IMG_URL + result_set[item.result_id].down_img_url}/>
                                                    <div className="hover_rank">
                                                        <p className="count">{item.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} 개</p>
                                                        <p className="per">{(item.count / num_success_count * 100).toFixed(2)} %</p>
                                                    </div>
                                                </div>
                                            )
                                        }) : null
                                }
                                <div className="main_rank_compo"/>
                            </div>
                        </div>
                        <div className="footer" style={{marginBottom: "40px"}}>
                            <p className="copyright">2020 Copyright @ TENDOM. All rights reserved.</p>
                            <a href="mailto:info@tendom.co.kr" className="copyright">Contact Us</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Main;
